<form class="key-value-array-form" [formGroup]="form">
  <app-form formArrayName="items">
    <ng-container *ngFor="let itemControl of itemsControl.controls; let itemIndex = index">
      <ng-container [formGroupName]="itemIndex">
        <app-row>
          <input
            *ngIf="!keySource.length; else keyDropdownTmp"
            pInputText
            type="text"
            formControlName="key"
            placeholder="Ключ"
            [class.loading]="loading"
          />
          <ng-template #keyDropdownTmp>
            <p-dropdown
              class="dropdown"
              formControlName="key"
              placeholder="Ключ"
              [options]="keySource"
              [editable]="true"
              [showClear]="true"
              [class.loading]="loading"
            />
          </ng-template>

          <input
            *ngIf="!valueSource.length; else valueDropdownTmp"
            pInputText
            type="text"
            formControlName="value"
            placeholder="Значение"
            [class.loading]="loading"
          />
          <ng-template #valueDropdownTmp>
            <p-dropdown
              class="dropdown"
              formControlName="value"
              placeholder="Значение"
              [options]="valueSource"
              [editable]="true"
              [showClear]="true"
              [class.loading]="loading"
            />
          </ng-template>

          <button
            pButton
            class="remove-button"
            icon="pi pi-trash"
            severity="danger"
            [size]="'small'"
            [text]="true"
            [disabled]="itemIndex === itemsControl.length - 1"
            [pTooltip]="'Удалить'"
            [tooltipPosition]="'right'"
            (click)="removeItem(itemIndex)"
          ></button>
        </app-row>
      </ng-container>
    </ng-container>
  </app-form>
</form>
